import {REPORT_COACHES_AT_RANK} from '/enum/records.enum';

export default {
  reportName: REPORT_COACHES_AT_RANK,
};
